import React from "react";
import "../scss/section.scss";

const Section = ({title, children, style}) => 
    (<section className="section" style={style}>
        <h6 className="section-title">{title}</h6>
        {children}
    </section>);

export default Section;